exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wizard-position span[data-v-46cd04a4]{cursor:pointer}.wizard-position span.disabled[data-v-46cd04a4]{cursor:not-allowed}.small-header[data-v-46cd04a4]{color:#9d9d9d}", ""]);

// exports
